export default {
  header: 'Method',
  groupKey: 'method',
  filters: [
    { text: 'Casting', id: 'casting' },
    { text: 'Investment Casting', id: 'investmentCasting' },
    { text: 'Sand Casting', id: 'sandCasting' },
    { text: 'Permanent Mold Casting', id: 'permanentMoldCasting' },
    { text: 'Die Casting', id: 'dieCasting' },
    { text: 'Centrifugal Casting', id: 'centrifugalCasting' },
    { text: 'Plaster Casting', id: 'plasterCasting' },
    // { text: 'Machining Or Other', id: 'machiningOther' },
    { text: 'Unspecified', id: 'unspecified' },
  ],
};



// WEBPACK FOOTER //
// ./src/config/searchFilters/methodFilters.js